export const confirmationConstants = {
    CONFIRMATION_SELECTED: 'CONFIRMATION_SELECTED'
  }